import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./LogoTop.module.css";
import logo from "../../assets/m_logo.png";

export default function LogoTop() {
  const ref = useRef<HTMLDivElement>(null);
  const balanceRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    const WA = window.Telegram?.WebApp;

    const place = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const safeTop = (WA as any)?.safeAreaInset?.top ?? 0;
      // просто ставим сразу после safeTop
      if (ref.current) {
        ref.current.style.top = `${safeTop + 8}px`;
      }
    };

    // Пересчитываем позицию сразу и с небольшой задержкой после перехода страницы
    place();

    // Добавляем задержку для пересчета после того, как стили MainPage очистились
    const timeoutId = setTimeout(place, 100);

    WA?.onEvent?.("safe_area_changed", place);
    WA?.onEvent?.("viewport_changed", place);

    return () => {
      clearTimeout(timeoutId);
      WA?.offEvent?.("safe_area_changed", place);
      WA?.offEvent?.("viewport_changed", place);
    };
  }, [location.pathname]);

  useEffect(() => {
    if (balanceRef.current) {
      if (location.pathname === "/") {
        balanceRef.current.style.backgroundColor = "transparent";
      } else {
        balanceRef.current.style.backgroundColor = "transparent";
      }
    }
  }, [location.pathname]);

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/");
  };
  const isMainPage =
    location.pathname === "/" ||
    location.pathname === "/index.html" ||
    (!["/catalog", "/saved", "/bucket"].includes(location.pathname) &&
      !location.pathname.startsWith("/banner/"));

  const isBannerPage = location.pathname.startsWith("/banner/");

  if (isMainPage || isBannerPage) {
    return null;
  }

  return (
    <div className={styles.wrap} ref={ref} onClick={handleNavigate}>
      <div className={styles.balance} ref={balanceRef}>
        <img src={logo} alt="logo" className={styles.icon} />
      </div>
    </div>
  );
}
